import * as actionTypes from 'constants/ActionTypes';

export function postGazetters(text, options) {
    return {
        type: actionTypes.POST_GAZETTERS.REQUEST,
        text,
        options,
    };
}

export function saveGazetters(gazetters) {
    return {
        type: actionTypes.SAVE_GAZETTERS.REQUEST,
        gazetters,
    };
}


export function removeGazetters() {
    return {
        type: actionTypes.REMOVE_GAZETTERS,
    };
}


// WEBPACK FOOTER //
// ./app/actions/gazetters.js